import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { catchError, map, tap } from 'rxjs/operators';
import { StorageService } from './storage.service';
import { CreateUserRequest } from '../model/prev/CreateUserRequest';
import { ValidationService } from './validation.service';

@Injectable({
  providedIn: 'root'
})
export class TransactionPrevImpService {
  headers = new HttpHeaders();
  params = new HttpParams();
  userB2c: any;
  createUserRole: any;
  private cacheableEndpoints = [
    '/IntoMawbp/getQueryDepartamento',
    '/IntoMawbp/getQueryCity',
    '/IntoMawbp/getQueryTipoDocumento',
    '/IntoMawbp/getQueryPais',
    '/IntoMawbp/getValidateCodeAirline',
    '/IntoMawbp/getQueryTipoDocumentoViaje',
    '/IntoMawbp/getQueryAerolinea',
    '/IntoMawbp/getQueryTipoCliente',
    '/IntoMawbp/getQueryBuscarOtrosDatosDIAN',
    '/IntoMawbp/getQueryBaseAdministracion',
    '/IntoMawbp/getQueryDisposicionCarga'
  ];

  private readonly NON_CO_RESPONSE = {
    response: '0001 - Exito',
    result: [{ codigo: '00', nombreDpto: '' }]
  };

  constructor(private httpClient: HttpClient, private storageService: StorageService, private validationService: ValidationService) {
    this.headers = this.headers.append('Service', 'Prev');
  }

  executeMethod(apiUrl: string, urlService: string, data?: any, jwt = true): Observable<any> {
    return this.httpClient.post<any>(`${apiUrl}` + `${urlService}`, data, { headers: this.headers })
      .pipe(
        catchError((error) => {
          if (error.status == 401) {
            alert("Acceso no Autorizado, saldra de la sesión.");
          }
          return "Ocurrió un error de conexión, por favor inténtelo de nuevo.";
        }
        ));
  }


  public downloadXml(apiUrl: string, urlService: string, data?: any): Observable<any> {
    return this.httpClient.post<any>(`${apiUrl}` + `${urlService}`, data, { observe: 'response', responseType: 'blob' as 'json', headers: this.headers }).pipe(map(res => {
      return res;
    }));
  }

  public save(apiUrl: string, urlService: string, data?: any): Observable<any> {
    return this.httpClient.post<any>(`${apiUrl}` + `${urlService}`, data, { headers: this.headers }).pipe(map(res => {
      return res;
    }));
  }

  public AssingFlights(apiUrl: string, urlService: string, data?: any): Observable<any> {
    return this.httpClient.post<any>(`${apiUrl}` + `${urlService}`, data, { headers: this.headers }).pipe(map(res => {
      return res;
    }));
  }

  public update(apiUrl: string, urlService: string, data?: any): Observable<any> {
    return this.httpClient.put<any>(`${apiUrl}` + `${urlService}`, data, { headers: this.headers }).pipe(map(res => {
      return res;
    }));
  }

  public getAll(apiUrl: string, urlService: string): Observable<any> {
    return this.httpClient.get<any>(`${apiUrl}` + `${urlService}`, { headers: this.headers }).pipe(map(res => {
      return res;
    }));
  }

  public async getAsync(apiUrl: string, urlService: string): Promise<Observable<any>> {
    return await this.httpClient.get<any>(`${apiUrl}` + `${urlService}`, { headers: this.headers }).toPromise()
  }

  public get(apiUrl: string, urlService: string, id?: any): Observable<any> {
    let httpParams = new HttpParams();
    httpParams = httpParams.append('id', id);
    return this.httpClient.get<any>(`${apiUrl}` + `${urlService}`, { headers: this.headers, params: httpParams }).pipe(map(res => {
      return res;
    }));
  }

  public delete(apiUrl: string, urlService: string, ids?: string[]): Observable<any> {
    let options = {
      headers: this.headers,
      body: JSON.stringify(ids)
    };
    return this.httpClient.delete<any>(`${apiUrl}` + `${urlService}`, options).pipe(map(res => {
      return res;
    }));
  }

  public createClient(apiUrl: string, urlService: string, newUser: CreateUserRequest): Observable<any> {
    let header = new HttpHeaders
    header = header.append('Service', 'Prev');
    header = header.append('Content-Type', 'application/json');
    return this.httpClient.post<any>(`${apiUrl}` + `${urlService}`, newUser, { headers: header, reportProgress: true })
  }

  public loadInfoNoHeaders(apiUrl: string, urlService: string, formData): Observable<any> {
    return this.httpClient.post<any>(`${apiUrl}` + `${urlService}`, formData, { reportProgress: true }).pipe(map(res => {
      return res;
    }));
  }

  private getCacheKeys(urlService: string, formData: FormData | any): { hashKey: string, hashKeyHash: string } {
    let hashKey = `cache_${urlService}`;
    let hashKeyHash = `cache_${urlService}_hash`;

    const endpointMappings = [
      { endpoint: '/IntoMawbp/getQueryDepartamento', key: 'strPais' },
      { endpoint: '/IntoMawbp/getQueryCity', key: 'strDpto' },
      { endpoint: '/IntoMawbp/getValidateCodeAirline', key: 'CodAerolinea', transform: (value: string) => value.trim().toUpperCase() },
      { endpoint: '/IntoMawbp/getQueryTipoDocumentoViaje', key: 'swGuia' },
      { endpoint: '/IntoMawbp/getQueryAerolinea', key: 'intOpFiltro' },
      { endpoint: '/IntoMawbp/getQueryBaseAdministracion', keys: ['idxBase', 'idxTipoBase'] },
      { endpoint: '/IntoMawbp/getQueryDisposicionCarga', key: 'strTDV' }
    ];

    const mapping = endpointMappings.find(mapping => urlService.includes(mapping.endpoint));
    if (mapping) {
      const { hashKey: newHashKey, hashKeyHash: newHashKeyHash } = this.generateCacheKeys(mapping, urlService, formData);
      hashKey = newHashKey;
      hashKeyHash = newHashKeyHash;
    }

    return { hashKey, hashKeyHash };
  }

  private generateCacheKeys(mapping: any, urlService: string, formData: FormData | any): { hashKey: string, hashKeyHash: string } {
    let hashKey = `cache_${urlService}`;
    let hashKeyHash = `cache_${urlService}_hash`;

    if (mapping.keys) {
      const values = this.getValuesFromKeys(mapping.keys, formData);
      if (this.areValuesValid(values)) {
        hashKey = `cache_${urlService}_${values.join('_')}`;
        hashKeyHash = `cache_${urlService}_${values.join('_')}_hash`;
      }
    } else {
      let value = this.getValueFromKey(mapping.key, formData);
      if (value && value !== 'undefined') {
        if (mapping.transform) {
          value = mapping.transform(value);
        }
        hashKey = `cache_${urlService}_${value}`;
        hashKeyHash = `cache_${urlService}_${value}_hash`;
      }
    }

    return { hashKey, hashKeyHash };
  }

  private getValuesFromKeys(keys: string[], formData: FormData | any): any[] {
    return keys.map(key => formData instanceof FormData ? formData.get(key) : formData[key]);
  }

  private areValuesValid(values: any[]): boolean {
    return values.every(value => value && value !== 'undefined');
  }

  private getValueFromKey(key: string, formData: FormData | any): any {
    return formData instanceof FormData ? formData.get(key) : formData[key];
  }

  private checkCache(hashKey: string, hashKeyHash: string): any {
    const cachedData = localStorage.getItem(hashKey);
    const cachedHash = localStorage.getItem(hashKeyHash);

    if (cachedData && cachedHash && this.validationService.verifyHash(cachedData, cachedHash)) {
      return JSON.parse(cachedData);
    }

    return null;
  }

  private cacheData(hashKey: string, hashKeyHash: string, data: any): void {
    const dataToCache = JSON.stringify(data);
    const hash = this.validationService.generateHash(dataToCache);
    localStorage.setItem(hashKey, dataToCache);
    localStorage.setItem(hashKeyHash, hash);
  }

  private checkNonCOQueryDepartamento(urlService: string, formData: FormData | any): Observable<any> | null {
    if (urlService.includes('/IntoMawbp/getQueryDepartamento')) {
      const strPais = formData instanceof FormData ? formData.get('strPais') : formData.strPais;
      if (strPais && strPais !== 'CO') {
        return of({ body: this.NON_CO_RESPONSE });
      }
    }
    return null;
  }

  public loadInfo(apiUrl: string, urlService: string, formData): Observable<any> {
    let headers = this.headers;

    const nonCOResponse = this.checkNonCOQueryDepartamento(urlService, formData);
    if (nonCOResponse) {
      return nonCOResponse;
    }

    if (this.cacheableEndpoints.includes(urlService)) {
      const { hashKey, hashKeyHash } = this.getCacheKeys(urlService, formData);
      const cachedData = this.checkCache(hashKey, hashKeyHash);

      if (cachedData) {
        return of({ body: cachedData });
      }

      return this.httpClient.post<any>(`${apiUrl}${urlService}`, formData, { headers, reportProgress: true }).pipe(
        tap(response => {
          if (response && response.body && response.body.response.includes("0001")) {
            this.cacheData(hashKey, hashKeyHash, response.body);
          }
        }),
        map(res => res)
      );
    } else {
      return this.httpClient.post<any>(`${apiUrl}${urlService}`, formData, { headers, reportProgress: true }).pipe(
        map(res => res)
      );
    }
  }

  public async loadInfoAsync(apiUrl: string, urlService: string, formData: any): Promise<any> {
    let headers = this.headers;

    const nonCOResponse = this.checkNonCOQueryDepartamento(urlService, formData);
    if (nonCOResponse) {
      return nonCOResponse.toPromise();
    }

    if (this.cacheableEndpoints.includes(urlService)) {
      const { hashKey, hashKeyHash } = this.getCacheKeys(urlService, formData);
      const cachedData = this.checkCache(hashKey, hashKeyHash);

      if (cachedData) {
        return { body: cachedData };
      }

      try {
        const response = await this.httpClient.post<any>(`${apiUrl}${urlService}`, formData, {
          headers,
          reportProgress: true
        }).toPromise();

        if (response && response.body) {
          this.cacheData(hashKey, hashKeyHash, response.body);
        }

        return response;
      } catch (error) {
        throw new Error('Error fetching data from API');
      }
    } else {
      return await this.httpClient.post<any>(`${apiUrl}${urlService}`, formData, {
        headers,
        reportProgress: true
      }).toPromise();
    }
  }
}
